import { Box, Flex, FormControl, FormErrorMessage, FormLabel, Input, VStack } from '@chakra-ui/react';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GenerateButton } from './GenerateButton';

interface PromptFormProps {
  onSubmit: (cardType: string, cardFor: string) => void;
  generateBtnLabel: string;
  isLoading: boolean;
}

export const PromptForm = ({ onSubmit, generateBtnLabel, isLoading }: PromptFormProps) => {
  const { t } = useTranslation('design_generator', { keyPrefix: 'cardGeneration.promptForm' });

  const [formErrors, setFormErrors] = useState({
    cardType: false,
    cardFor: false,
  });

  const cardTypeInputRef = useRef<HTMLInputElement>(null);
  const cardForInputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = useCallback(() => {
    const cardType = cardTypeInputRef.current?.value;
    const cardFor = cardForInputRef.current?.value;

    // Validation for card type and card for inputs
    if (!cardType || !cardFor) {
      setFormErrors({
        cardType: !cardType,
        cardFor: !cardFor,
      });
      return;
    }

    // reset form errors
    setFormErrors({
      cardType: false,
      cardFor: false,
    });

    onSubmit(cardType.trim(), cardFor.trim());
  }, [onSubmit]);

  return (
    <VStack w='full' spacing={4}>
      <Box w='full'>
        <FormControl isInvalid={formErrors.cardType}>
          <FormLabel fontSize='sm'>{t('cardType.label')}</FormLabel>
          <Input ref={cardTypeInputRef} type='text' placeholder={t('cardType.placeholder')} />
          {formErrors.cardType && <FormErrorMessage aria-invalid={true}>{t('cardType.error')}</FormErrorMessage>}
        </FormControl>
        <FormControl isInvalid={formErrors.cardFor}>
          <FormLabel fontSize='sm' mt={4}>
            {t('cardFor.label')}
          </FormLabel>
          <Input ref={cardForInputRef} type='text' placeholder={t('cardFor.placeholder')} />
          {formErrors.cardFor && <FormErrorMessage aria-invalid={true}>{t('cardFor.error')}</FormErrorMessage>}
        </FormControl>
      </Box>
      <Flex w='full' justifyContent='flex-end'>
        <GenerateButton onClick={handleSubmit} label={generateBtnLabel} isLoading={isLoading} />
      </Flex>
    </VStack>
  );
};
